<template>
  <sonko-layout>
    <vue-headful title="eWak" />
    <v-flex xs12 class="mx-3 mb-2">
      <sonko-jobs-menu></sonko-jobs-menu>
    </v-flex>

    <v-flex xs12 class="mx-3 mb-2">
      <v-spacer></v-spacer>
      <v-btn dark small class="btnColor" to="/sonko/create/job">
        <v-icon>add</v-icon>Post a job
      </v-btn>
    </v-flex>
    

    <v-flex xs12 class="mx-3 mb-2">
      <v-alert
        v-if="jobs.length<1"
        :value="true"
        type="info"
      >You dont have {{$route.params.status}} jobs.</v-alert>
      <jobs-list  :jobs="jobs" :jobStatus="jobStatus"></jobs-list>
      <v-pagination v-if="jobs.length>=1"
        v-model="currentPage"
        :length="Math.ceil(amount/perPage)"
        @input="onPageChange"
    ></v-pagination>
    </v-flex>
  </sonko-layout>
</template>

<script>
import SonkoJobsMenu from "./_components/jobs_menu.vue";
import JobsList from "./_components/jobs_list.vue";
import { mapGetters } from "vuex";
export default {
  name: "SonkoJobsIndex",
  components: {
    SonkoJobsMenu,
    JobsList
  },
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      jobs: [],
      jobStatus: null,
      currentPage: typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1,
      perPage: 10,
      amount: 0,
      cStatus: this.$route.params.status
    };
  },
  watch: {
    "$route.params.status": {
      handler: "getJobs",
      immediate: true
    }
  },
  methods: {
    getJobs(val) {
      const status = val;
      this.jobStatus = val;
      if (status !== undefined) {
        let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
        this.$store
          .dispatch("get", "/job/mysonkojobs/" + this.user._id + "/" + status+"/"+cPage)
          .then(res => {
            this.currentPage = cPage;
            this.jobs = res.jobs;
            this.amount = res.amount;
          });
      }
    },
    onPageChange(page) {
      this.$router.push({query: {page: page}});
      this.getJobs(this.$route.params.status);
    }
  },
  mounted() {
        this.getJobs(this.$route.params.status);
    },
  created() {
    this.getJobs(this.$route.params.status);
  }
};
</script>
